module.exports = __webpack_public_path__ + "jmeter.32cqaTZd.svg";